<template>
  <div class="message-wrapper">
    <div class="message-header">
      <div class="message-tab">
        <div :class="['tab-item',  tab.value === currentTab ? 'is-active' : '']" v-for="tab in tabs" :key="tab.value" @click="handleChangeTab(tab)">
          <span :class="[taskShowRed && tab.value === 2 ? 'on' : '']">{{ tab.label }}</span>
        </div>
      </div>
      <div class="message-clear" @click="clearAllMessage">清空记录</div>
    </div>

    <div class="message-content">
      <FileUploadList ref="fileUploadListRef" v-show="currentTab === 1" @open="onOpenMessage"/>
      <TaskFeedback v-show="currentTab === 2"  :list="taskFeedbackList" @open="openDetail1" @load="onLoad"/>
      <SystemNotice ref="systemNoticeRef" v-show="currentTab === 3" @load="onLoad" />
    </div>
  </div>
</template>

<script>
import FileUploadList from "./fileUploadList.vue";
import TaskFeedback from './taskFeedback.vue'
import SystemNotice from './systemNotice.vue'
export  default {
  name: 'MessageListComponent',
  components: {
    FileUploadList,
    TaskFeedback,
    SystemNotice
  },
  props: {
    taskFeedbackList: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    taskShowRed: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      currentTab: 1,
      tabs:[
        {
          label: '文件传输',
          value: 1
        },
        {
          label: '任务反馈',
          value: 2
        },
        {
          label: '系统通知',
          value: 3
        }
      ]
    }
  },
  watch: {
    visible(n) {
      if(n) {
        this.currentTab = 1
      }
    },
    currentTab(n){
      if(n === 2 || n === 3 ) {
        this.$emit('load', n, 'init')
      }
    }
  },
  methods: {
    handleChangeTab(tab) {
      this.currentTab = tab.value
    },
    openDetail1(item){
      this.$emit('open', item)
    },
    onLoad(){
      this.$emit('load', this.currentTab)
    },
    clearAllMessage(){
      this.$refs.fileUploadListRef.clearAll()
      this.$refs.systemNoticeRef.clearAll()
      this.$emit('clearAll')

    },
    onOpenMessage(){
      this.$emit('show')
    }
  }
}
</script>

<style lang="less" scoped>
.message-wrapper {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  .message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    margin-bottom: 14px;
  }
  .message-tab {
    display: flex;
    align-items: center;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #41B48B;
    .tab-item {
      position: relative;
      width: 110px;
      font-weight: 400;
      font-size: 12px;
      color: #829191;
      text-align: center;
      line-height: 30px;
      span.on {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          right: -5px;
          top: -4px;
          width: 5px;
          height: 5px;
          background: #FF555A;
          border-radius: 5px;
        }
      }
      &:before {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 20px;
        background: #EAEAEA;
      }
      &:last-child:before {
        display: none;
      }

      &.is-active {
        background: #41B48B;
        color: #fff;
        &:before {
          background: #41B48B;
        }
      }
    }
  }
  .message-clear {
    padding-left: 20px;
    font-size: 14px;
    color: #41B48C;
    line-height: 1.2;
    background-image: url("../../assets/img/headline/clear.svg");
    background-position: left center;
    background-size: 14px 14px;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .message-content {
    flex: 1;
    overflow: hidden;
  }
}
</style>

